const StaticIcon = ({ size = 24, className = "", ...props }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        opacity="0.3"
        d="M7.09091 21.0002H3.81818C3.60119 21.0002 3.39308 20.914 3.23964 20.7605C3.0862 20.6071 3 20.399 3 20.182V13.6365C3 13.4195 3.0862 13.2114 3.23964 13.058C3.39308 12.9046 3.60119 12.8184 3.81818 12.8184H7.09091C7.3079 12.8184 7.51601 12.9046 7.66945 13.058C7.82289 13.2114 7.90909 13.4195 7.90909 13.6365V20.182C7.90909 20.399 7.82289 20.6071 7.66945 20.7605C7.51601 20.914 7.3079 21.0002 7.09091 21.0002Z"
        fill="currentColor"
      />
      <path
        d="M13.6378 21H10.3651C10.1481 21 9.93995 20.9138 9.78652 20.7604C9.63308 20.6069 9.54688 20.3988 9.54688 20.1818V3.81818C9.54688 3.60119 9.63308 3.39308 9.78652 3.23964C9.93995 3.0862 10.1481 3 10.3651 3H13.6378C13.8548 3 14.0629 3.0862 14.2163 3.23964C14.3698 3.39308 14.456 3.60119 14.456 3.81818V20.1818C14.456 20.3988 14.3698 20.6069 14.2163 20.7604C14.0629 20.9138 13.8548 21 13.6378 21Z"
        fill="currentColor"
      />
      <path
        opacity="0.55"
        d="M20.1808 21H16.908C16.691 21 16.4829 20.9138 16.3295 20.7603C16.176 20.6069 16.0898 20.3988 16.0898 20.1818V10.3636C16.0898 10.1466 16.176 9.93849 16.3295 9.78505C16.4829 9.63161 16.691 9.54541 16.908 9.54541H20.1808C20.3977 9.54541 20.6059 9.63161 20.7593 9.78505C20.9127 9.93849 20.9989 10.1466 20.9989 10.3636V20.1818C20.9989 20.3988 20.9127 20.6069 20.7593 20.7603C20.6059 20.9138 20.3977 21 20.1808 21Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default StaticIcon;
